import { getEnvVar } from "../functions/getEnvVar";

const mode = getEnvVar("VITE_ENVIRONMENT");

export const IS_LOCAL_ENV = mode === "local";
export const IS_DEV_ENV = mode == "development" || IS_LOCAL_ENV;
export const IS_PROD_ENV = mode == "production";
